import axios from '@/common/axios';
import { YYGL } from '../constants/funcUrl';

/**
 * 运营管理
 */
const yyglAction = {
  // 企业注册审核列表
  getApprovelList: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.APPROVELLIST, params);
  },
  // 查询企业信息
  getEnterprise: ({ commit }, params) => {
    return axios.getAsyncWithConcat(commit, YYGL.ENTERPRISE, params);
  },
  // 查询企业详细信息
  getEnterpriseDetails: ({ commit }, params) => {
    return axios.getAsyncWithConcat(commit, YYGL.ENTERPRISEDETAILS, params);
  },
  // 查询注册企业信息
  getEnterpriseRegister: ({ commit }, params) => {
    return axios.getAsyncWithConcat(commit, YYGL.ENTERPRISEREGISTER, params);
  },
  // 审核企业注册
  putApprove: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.APPROVE, params);
  },
  // 查询企业注册审核信息
  getEnterpriseApprove: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.ENTERPRISEAPPROVE, params);
  },
  // 课程报名/缴费/开通审核列表
  getLearnLearnapprove: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNLEARNAPPROVE, params);
  },
  // 培训超期缴费批量审核
  getLearnExpirJfApprove: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNLEARNCQJFAPPROVE, params);
  },
  // 课程报名待审核数量
  getLearnApproveCount1: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNLEARNAPPROVECOUNT1, params);
  },
  // 课程缴费待审核数量
  getLearnApproveCount2: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNLEARNAPPROVECOUNT2, params);
  },
  // 课程开通待审核数量
  getLearnApproveCount3: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNLEARNAPPROVECOUNT3, params);
  },
  // 课程报名待审核数量
  getJCYLearnApproveCount1: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNJCYLEARNAPPROVECOUNT1, params);
  },
  // 课程缴费待审核数量
  getJCYLearnApproveCount2: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNJCYLEARNAPPROVECOUNT2, params);
  },
  // 审核课程报名/缴费/开通
  postLearnLearnapprove: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.LEARNLEARNAPPROVE, params);
  },
  // 审核课程报名/缴费/开通
  postLearnExpirJfApprove: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.LEARNLEARNCQJFAPPROVE, params);
  },
  // 导入进账记录
  postImportPaymentRecords: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.LEARNIMPORTPAYMENTRECORDS, params);
  },
  // 关闭课程报名
  postLearnClose: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.LEARCLOSE, params);
  },
  // 暂停开票
  postPauseInvoice: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.LEARPAUSEINVOICE, params);
  },
  // 删除订单学员
  postDeleteLearnEmployee: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.LEARNDELETEEMPLOYEE, params);
  },
  // 获得订单企业信息
  getLearnEnterprise: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNENTERPRISE, params);
  },
  // 补考报名/缴费/开通审核列表
  getMakeUpMakeUpApprove: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.MAKEUPMAKEUPAPPROVE, params);
  },
  // 补考报名待审核数量
  getMakeUpApproveCount1: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.MAKEUPMAKEUPAPPROVECOUNT1, params);
  },
  // 补考缴费待审核数量
  getMakeUpApproveCount2: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.MAKEUPMAKEUPAPPROVECOUNT2, params);
  },
  // 补考开通待审核数量
  getMakeUpApproveCount3: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.MAKEUPMAKEUPAPPROVECOUNT3, params);
  },
  // 审核补考报名/缴费/开通
  postMakeUpMakeUpApprove: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.MAKEUPMAKEUPAPPROVE, params);
  },
  // 审核补考报名/缴费/开通
  postMakeUpMakeUpKtApprove: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.MAKEUPMAKEUPKTAPPROVE, params);
  },
  // 企业注册待审核数量
  getPendingApprovalCount: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.PENDINGAPPROVALCOUNT, params);
  },
  // 运营学习管理列表
  getLearningmgtYY: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNINGMGTYY, params);
  },
  // 报名课程信息
  getLearningmgt: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNINGMGT, params);
  },
  // 报名课程学员信息
  getLearningmgtEmployee: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNINGMGTEMPLOYEE, params);
  },
  // 报名课程学员模拟考试记录
  getLearningmgtEmployeeMockExamRecords: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNINGMGTEMPLOYEEMOCKEXAMRECORDS, params);
  },
  // 报名课程学员课时信息
  getLearningmgtEmployeeLesson: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNINGMGTEMPLOYEELESSON, params);
  },
  getLearningmgtEmployeeLessonCatalogs: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNINGMGTEMPLOYEELESSONCATALOGS, params);
  },
  // 报名课程学员课时信息列表
  getLearningMGTEmployeeLessonAlbumDetails: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNINGMGTEMPLOYEELESSONALBUMDETAILS, params);
  },
  // 报名课程学员课时学习日志
  getLearningmgtEmployeeLessonLog: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNINGMGTEMPLOYEELESSONLOG, params);
  },
  // 学员导出列表接口
  getSearchexporTemployeeList: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.SEARCHEXPORTEMPLOYEE, params);
  },
  // 学员导出列表接口
  getExportJcy2026Employees: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.SEARCHEXPORTJCY2026, params);
  },
  // 在服务器上导出学员 Excel
  getExportEmployeeExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EXPORTEMPLOYEEEXCEL, params);
  },
  // 在服务器上导出学员 Excel
  postExportJcy2026Excel: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXPORTJCY2026EXCEL, params);
  },
  // 在服务器上导出全部学员 Excel
  postExportJcy2026AllExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXPORTJCY2026ALLEXCEL, params);
  },
  getLearnApproveExportBdyExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNAPPROVEEXPORTBDYEXCEL, params);
  },
  getLearnApproveExportBdyZpZip: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNAPPROVEEXPORTBDYZPZIP, params);
  },
  getLearnApproveExportBdyHzbExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNAPPROVEEXPORTBDYHZBEXCEL, params);
  },
  getLearnApproveExportJsgrExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNAPPROVEEXPORTJSGREXCEL, params);
  },
  // 在服务器上导出白底照片 Zip
  getExportEmployeeZp: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EXPORTEMPLOYEEZP, params);
  },
  // 在服务器上导出八大员学员信息Excel
  getExportBdyExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EXPORTBDYEXCEL, params);
  },
  getExportJsgrExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EXPORTJSGREXCEL, params);
  },
  getYYHasCourse: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.YYHASCOURSE, params);
  },
  // 更新课程报名开票信息
  postLearnapproveUpdateinvoice: ({ commit }, params) => {
    return axios.putFormDataAsync(
      commit,
      YYGL.LEARNAPPROVEUPDATEINVOICE,
      params
    );
  },
  // 更新报考（住建云）信息
  postLearnUpdateRegisterZJY: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.LEARNUPDATEREGISTERZJY, params);
  },
  // 更新学员报考（住建云）信息
  putLearnEmployeeRegisterZJY: ({ commit }, params) => {
    return axios.putFormDataAsync(
      commit,
      YYGL.LEARNUPDATEEMPLOYEEREGISTERZJY,
      params
    );
  },
  // 导出课程审核 Excel
  getLearnApproveExportExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNAPPROVEEXPORTEXCEL, params);
  },
  // 导出课程审核学员Excel
  getLearnApproveExportEmployeeExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNAPPROVEEXPORTEMPLOYEEEXCEL, params);
  },
  // 导出八大员课程报名信息
  exportLearnBdyBMExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNEXPORTBDYBM, params);
  },
  // 开始导出八大员课程报名资料
  initExportLearnBdyBMPic: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.LEARNEXPORTBDYBMPICINIT,
      params
    );
  },
  // 导出八大员课程报名资料
  exportLearnBdyBMPic: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.LEARNEXPORTBDYBMPIC, params);
  },
  // 结束导出八大员课程报名资料
  endLearnBdyBMPic: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.LEARNEXPORTBDYBMPICEND, params);
  },
  // 导出检测员初陪课程报名Excel
  postExportJcyBmbExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.LEARNEXPORTJCYBMBEXCEL, params);
  },
  // 导出检测员初陪课程报名Excel
  postExportJcyScBmbExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.LEARNEXPORTJCYSCBMBEXCEL, params);
  },
  // 更新补考报名开票信息
  postMakeUpApproveUpdateInvoice: ({ commit }, params) => {
    return axios.putFormDataAsync(
      commit,
      YYGL.MAKEUPAPPROVEUPDATEINVOICE,
      params
    );
  },
  // 导出补考报名审核 Excel 接口
  getMakeUpApproveExportApproveExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.MAKEUPAPPROVEEXPORTAPPROVEEXCEL, params);
  },
  // 导出补考报名缴费审核 Excel 接口
  getMakeUpApproveExportjfApproveExcel: ({ commit }, params) => {
    return axios.getAsync(
      commit,
      YYGL.MAKEUPAPPROVEEXPORTJFAPPROVEEXCEL,
      params
    );
  },
  // 测试考场管理列表
  getTestRooms: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTROOMS, params);
  },
  // 查询测试考场管理详情
  getTestRoomById: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTROOM, params);
  },
  // 添加测试考场
  postTestRoom: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.TESTMGTROOM, params);
  },
  // 编辑测试考场
  putTestRoom: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.TESTMGTROOM, params);
  },
  // 删除测试考场
  deleteTestRoom: ({ commit }, params) => {
    return axios.deleteAsyncWithConcat(commit, YYGL.TESTMGTROOM, params);
  },

  // 测试批次列表
  getTestBatchs: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTBATCHS, params);
  },
  // 查询批次计划详情
  getTestBatchDetailsById: ({ commit }, params) => {
    return axios.getAsyncWithConcat(commit, YYGL.TESTMGTBATCHDETAILS, params);
  },
  // 所有测试批次列表
  getCourseTestBatchs: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTCOURSEBATCHS, params);
  },
  // 查询测试批次学员列表
  getTestBatchEmployees: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTBATCHEMPLOYEES, params);
  },
  // 获得测试批次添加学员列表
  getTestBatchAddEmployees: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTBATCHADDEMPLOYEES, params);
  },
  // 获得测试批次专业统计列表
  getTestBatchJobStats: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTBATCHJOBSTATS, params);
  },
  // 添加测试批次
  postTestBatch: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.TESTMGTBATCH, params);
  },
  // 编辑测试批次
  putTestBatch: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.TESTMGTBATCH, params);
  },
  // 删除测试批次
  deleteTestBatch: ({ commit }, params) => {
    return axios.deleteAsyncWithConcat(commit, YYGL.TESTMGTBATCH, params);
  },
  // 添加测试批次学员
  postTestBatchEmployee: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.TESTMGTBATCHADDEMPLOYEES,
      params
    );
  },
  // 删除测试批次学员
  deleteTestBatchEmployee: ({ commit }, params) => {
    return axios.deleteAsync(commit, YYGL.TESTMGTBATCHEMPLOYEE, params);
  },
  // 修改学员重点练习
  putTestBatchPracticeImportant: ({ commit }, params) => {
    return axios.putFormDataAsync(
      commit,
      YYGL.TESTMGTBATCHPRACTICEIMPORTANT,
      params
    );
  },
  // 修改学员补考报名
  putTestBatchAllMakeUp: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.TESTMGTBATCHALLMAKEUP, params);
  },
  // 上传省培必修合格名单
  importUploadSphgExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.TESTMGTBATCHIMPORTSPBXEXCEL,
      params
    );
  },
  // 导入学员名单
  importTestBatchEmployeeExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.TESTMGTBATCHIMPORTEMPLOYEEEXCEL,
      params
    );
  },
  // 导出测试学员
  exportTestBatchEmployeeExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTBATCHEXPORTEMPLOYEEEXCEL, params);
  },

  // 培训计划列表
  getTestTrains: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTTRAINS, params);
  },
  // 获得所有培训计划列表
  getCourseTestTrains: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTCOURSETRAINS, params);
  },
  // 查询培训计划详情
  getTestTrainDetailsById: ({ commit }, params) => {
    return axios.getAsyncWithConcat(commit, YYGL.TESTMGTTRAINDETAILS, params);
  },
  // 培训计划学员列表
  getTestTrainEmployees: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTTRAINEMPLOYEES, params);
  },
  // 添加培训计划
  postTestTrain: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.TESTMGTTRAIN, params);
  },
  // 编辑培训计划
  putTestTrain: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.TESTMGTTRAIN, params);
  },
  // 删除培训计划
  deleteTestTrain: ({ commit }, params) => {
    return axios.deleteAsyncWithConcat(commit, YYGL.TESTMGTTRAIN, params);
  },
  // 添加培训学员
  postTestTrainEmployees: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.TESTMGTTRAINEMPLOYEES, params);
  },
  // 添加全部测试场次学员
  postAllTestTrainEmployees: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.TESTMGTTRAINALLEMPLOYEES,
      params
    );
  },
  // 删除培训学员
  deleteTestTrainEmployee: ({ commit }, params) => {
    return axios.deleteAsync(commit, YYGL.TESTMGTTRAINEMPLOYEE, params);
  },
  // 修改学员重点练习
  putTestTrainPracticeImportant: ({ commit }, params) => {
    return axios.putFormDataAsync(
      commit,
      YYGL.TESTMGTTRAINPRACTICEIMPORTANT,
      params
    );
  },
  // 导出培训学员
  exportTestTrainEmployeeExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTTRAINEXPORTEMPLOYEEEXCEL, params);
  },
  // 导出培训计划课程课时详情
  exportTestTrainLessonExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTTRAINEXPORTLESSONEXCEL, params);
  },
  // 开始导出培训学员照片
  initExportTestTrainEmployeeZp: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.TESTMGTTRAININITEXPORTEMPLOYEEZP,
      params
    );
  },
  // 导出培训学员照片
  exportTestTrainEmployeeZp: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.TESTMGTTRAINEXPORTEMPLOYEEZP,
      params
    );
  },
  // 结束导出培训学员照片
  endExportTestTrainEmployeeZp: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.TESTMGTTRAINENDEXPORTEMPLOYEEZP,
      params
    );
  },
  // 修改学员重点练习
  putTestTrainAllMakeUp: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.TESTMGTTRAINALLMAKEUP, params);
  },

  // 查询测试场次状态列表
  getTestSessionStates: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTSESSIONSTATES, params);
  },
  // 测试场次列表
  getTestSessions: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTSESSIONS, params);
  },
  // 查询测试场次详情
  getTestSessionDetailsById: ({ commit }, params) => {
    return axios.getAsyncWithConcat(commit, YYGL.TESTMGTSESSIONDETAILS, params);
  },
  // 查询测试场次学员列表
  getTestSessionEmployees: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTSESSIONEMPLOYEES, params);
  },
  // 查询测试场次学员列表
  getTestSessionEmployeeAdmissionTicketUrl: ({ commit }, params) => {
    return axios.getAsync(
      commit,
      YYGL.TESTMGTSESSIONEMPLOYEEADMISSIONTICKET,
      params
    );
  },
  // 添加测试场次
  postTestSession: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.TESTMGTSESSION, params);
  },
  // 编辑测试场次
  putTestSession: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.TESTMGTSESSION, params);
  },
  // 删除测试场次
  deleteTestSession: ({ commit }, params) => {
    return axios.deleteAsyncWithConcat(commit, YYGL.TESTMGTSESSION, params);
  },
  // 查询测试场次添加学员列表
  getTestSessionAddEmployees: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTSESSIONADDEMPLOYEES, params);
  },
  // 添加测试场次学员
  postTestSessionEmployees: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.TESTMGTSESSIONEMPLOYEES,
      params
    );
  },
  // 编辑测试场次学员
  putTestSessionEmployee: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.TESTMGTSESSIONEMPLOYEE, params);
  },
  // 删除测试场次学员
  deleteTestSessionEmployee: ({ commit }, params) => {
    return axios.deleteAsync(commit, YYGL.TESTMGTSESSIONEMPLOYEE, params);
  },
  // 修改学员重点练习
  putTestSessionPracticeImportant: ({ commit }, params) => {
    return axios.putFormDataAsync(
      commit,
      YYGL.TESTMGTSESSIONPRACTICEIMPORTANT,
      params
    );
  },
  // 初始化准考证
  initTestSessionAdmissionTicket: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.TESTMGTSESSIONINITADMISSIONTICKET,
      params
    );
  },
  // 生成准考证
  generateTestSessionAdmissionTicket: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.TESTMGTSESSIONGENERATEADMISSIONTICKET,
      params
    );
  },
  // 准考证生成结束
  endTestSessionAdmissionTicket: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.TESTMGTSESSIONENDADMISSIONTICKET,
      params
    );
  },
  // 导出测试学员
  exportTestSessionEmployeeExcel: ({ commit }, params) => {
    return axios.getAsync(
      commit,
      YYGL.TESTMGTSESSIONEXPORTEMPLOYEEEXCEL,
      params
    );
  },
  // 导入测试学员
  importTestSessionEmployeeExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.TESTMGTSESSIONIMPORTEMPLOYEEEXCEL,
      params
    );
  },
  // 自动分配座位号
  assignTestSessionEmployeeSeatNumber: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.TESTMGTSESSIONASSIGNSEATNUMBER,
      params
    );
  },
  // 导入测试学员成绩
  importTestSessionScoreExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.TESTMGTSESSIONIMPORTSCOREEXCEL,
      params
    );
  },
  // 导出成绩名单
  exportTestSessionScoreExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.TESTMGTSESSIONEXPORTSCOREEXCEL,
      params
    );
  },
  // 修改学员重点练习
  // putEmployeePracticeImportant: ({
  //   commit
  // }, params) => {
  //   return axios.putFormDataAsync(commit, YYGL.TESTMGTEMPLOYEEPRACTICEIMPORTANT, params);
  // },
  // 导出测试用表
  exportTestSessionTestExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.TESTMGTSESSIONEXPORTTESTEXCEL,
      params
    );
  },
  // 查询省培同步日志
  getZjpxTrains: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTZJPXTRAINS, params);
  },

  // 三类特种测试批次列表
  getZjyTestBatchs: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.ZJYTESTMGTBATCHS, params);
  },
  // 三类特种测试批次详情
  getZjyTestBatchDetailsById: ({ commit }, params) => {
    return axios.getAsyncWithConcat(
      commit,
      YYGL.ZJYTESTMGTBATCHDETAILS,
      params
    );
  },
  // 三类特种测试批次学员列表
  getZjyTestBatchEmployees: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.ZJYTESTMGTBATCHEMPLOYEES, params);
  },
  // 三类特种测试批次审核学员列表
  getZjyTestBatchApproveEmployees: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.ZJYTESTMGTBATCHAPPROVEEMPLOYEES, params);
  },
  // 三类特种测试批次待审核学员数量
  getZjyTestBatchApproveEmployeeCount: ({ commit }, params) => {
    return axios.getAsync(
      commit,
      YYGL.ZJYTESTMGTBATCHAPPROVEEMPLOYEECOUNT,
      params
    );
  },
  // 审批三类特种测试批次学员报名
  postApproveZjyTestBatchEmployees: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.ZJYTESTMGTBATCHEMPLOYEESAPPROVE,
      params
    );
  },
  // 添加三类特种测试批次
  postZjyTestBatch: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.ZJYTESTMGTBATCH, params);
  },
  // 编辑三类特种测试批次
  putZjyTestBatch: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.ZJYTESTMGTBATCH, params);
  },
  // 删除三类特种测试批次
  deleteZjyTestBatch: ({ commit }, params) => {
    return axios.deleteAsyncWithConcat(commit, YYGL.ZJYTESTMGTBATCH, params);
  },
  // 导入测试学员成绩
  importZjyTestBatchScoreExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.ZJYTESTMGTBATCHSCOREIMPORT,
      params
    );
  },
  // 导入三类特种测试学员成绩
  importZjyTestBatchEmployeeExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.ZJYTESTMGTBATCHEMPLOYEEIMPORT,
      params
    );
  },
  // 删除三类特种测试批次
  deleteZjyTestBatchEmployee: ({ commit }, params) => {
    return axios.deleteAsync(commit, YYGL.ZJYTESTMGTBATCHEMPLOYEE, params);
  },

  // 企业管理列表
  getEnterprises: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.ENTERPRISEENTERPRISES, params);
  },
  // 企业档案-报名记录
  getEnterpriseLearns: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.ENTERPRISELEARNS, params);
  },
  // 企业档案-测试记录
  getEnterpriseTests: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.ENTERPRISETESTS, params);
  },
  // 企业档案-学员信息
  getEnterpriseEmployees: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.ENTERPRISEEMPLOYEES, params);
  },
  // 企业档案-三类特种测试信息
  getEnterpriseZjyTestDetails: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.ENTERPRISEZJYTESTDETAILS, params);
  },
  // 企业档案-三类特种测试学员信息
  getEnterpriseZjyTestEmployees: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.ENTERPRISEZJYTESTEMPLOYEES, params);
  },
  // 企业档案-三类特种测试学员测试记录
  getEnterpriseZjyTestEmployeeRecord: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.ENTERPRISEZJYTESTEMPLOYEERECORD, params);
  },
  // 企业档案-八大员测试信息
  getEnterpriseExamDetails: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.ENTERPRISEBDYTESTDETAILS, params);
  },
  // 企业档案-八大员测试学员信息
  getEnterpriseExamEmployees: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.ENTERPRISEBDYTESTEMPLOYEES, params);
  },
  // 企业档案-三类特种测试学员测试记录
  getEnterpriseExamEmployeeRecord: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.ENTERPRISEBDYTESTEMPLOYEERECORD, params);
  },
  // 修改企业信息
  putEnterprise: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.ENTERPRISE, params);
  },
  // 解绑企业帐号
  unlockEnterpriseLogin: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.ENTERPRISEUNLOCKLOGIN, params);
  },
  // 获得开票申请列表
  getYYInvoiceApproves: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.INVOICEAPPROVEYY, params);
  },
  // 获得待开票申请数量
  getInvoiceApproveCount1: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.INVOICEAPPROVECOUNT1, params);
  },
  // 获得待开票申请数量
  getInvoiceApproveCount2: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.INVOICEAPPROVECOUNT2, params);
  },
  // 获得待开票申请数量
  getInvoiceApproveCount3: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.INVOICEAPPROVECOUNT3, params);
  },
  // 获得待开票申请数量
  getInvoiceApproveCount4: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.INVOICEAPPROVECOUNT4, params);
  },
  // 导出电票文件
  postInitExportInvoiceApprove: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.INVOICEAPPROVEEXPORTINIT, params);
  },
  // 导出电票文件
  postGenerateExportInvoiceApprove: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.INVOICEAPPROVEEXPORTGENERATE, params);
  },
  // 导出电票文件
  postEndExportInvoiceApprove: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.INVOICEAPPROVEEXPORTEND, params);
  },
  // 导出批量开票文件Excel
  postExportInvoiceApproveDpwjExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.INVOICEAPPROVEEXPORTDPWJEXCEL, params);
  },
  // 审核开票申请
  putApproveInvoice: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.INVOICEAPPROVEAPPROVE, params);
  },
  // 审核开票申请
  putUpdateInvoiceApproveContract: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.INVOICEAPPROVECONTRACT, params);
  },
  // 批量导入发票Zip
  postImportInvoiceDzfpZip: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.INVOICEAPPROVEIMPORTZIP, params);
  },
  // 获得强制开票订单列表
  getInvoiceMandatoryLearns: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.INVOICEAPPROVEMANDATORYLEARNS, params);
  },
  // 强制开票
  postApplyMandatoryInvoice: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.INVOICEAPPROVEAPPLYMANDATORY, params);
  },
  // 取消强制开票
  postCancelInvoiceApprove: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.INVOICEAPPROVECANCEL, params);
  },
  // 查询最近测试计划列表
  getNewsTestPlan: ({ commit }, params) => {
    return axios.getAsyncWithConcat(commit, YYGL.NEWSTESTPLAN, params);
  },
  // 查询测试计划类别
  getNewsTestPlanTypes: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.NEWSTESTPLANTYPES, params);
  },
  // 添加最近测试计划列表
  postNewsTestPlan: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.NEWSTESTPLAN, params);
  },
  // 编辑最近测试计划列表
  putNewsTestPlan: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.NEWSTESTPLAN, params);
  },
  // 删除最近测试计划
  deleteNewsTestPlan: ({ commit }, params) => {
    return axios.deleteAsyncWithConcat(commit, YYGL.NEWSTESTPLAN, params);
  },

  // 查询新闻种类
  getNewsCategorys: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.NEWSCATEGORYS, params);
  },
  // 查询新闻列表
  getNewsYY: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.NEWSYY, params);
  },
  // 新闻置顶
  postNewsTop: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.NEWSTOP, params);
  },
  // 添加新闻
  postNews: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.NEWS, params);
  },
  // 编辑新闻
  putNews: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.NEWS, params);
  },
  // 删除新闻
  deleteNews: ({ commit }, params) => {
    return axios.deleteAsyncWithConcat(commit, YYGL.NEWS, params);
  },

  // 学员管理列表
  getEmployees: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EMPLOYEES, params);
  },
  // 查询学员详情
  getEmployeeDetails: ({ commit }, params) => {
    return axios.getAsyncWithConcat(commit, YYGL.EMPLOYEEDETAILS, params);
  },
  // 修改学员名称
  putEmployeeName: ({ commit }, params) => {
    return axios.putAsync(commit, YYGL.EMPLOYEENAME, params);
  },
  // 修改学员名称
  putEmployeePic: ({ commit }, params) => {
    return axios.putAsync(commit, YYGL.EMPLOYEEPIC, params);
  },
  // 修改学员身份证
  putEmployeeIdNumber: ({ commit }, params) => {
    return axios.putAsync(commit, YYGL.EMPLOYEEIDNUMBER, params);
  },
  // 修改学员性别
  putEmployeeSex: ({ commit }, params) => {
    return axios.putAsync(commit, YYGL.EMPLOYEESEX, params);
  },
  // 修改学员企业
  putEmployeeEnterprise: ({ commit }, params) => {
    return axios.putAsync(commit, YYGL.EMPLOYEEENTERPRISE, params);
  },
  // 重置学员密码
  resetEmployeePassword: ({ commit }, params) => {
    return axios.postAsync(commit, YYGL.EMPLOYEERESETPASSWORD, params);
  },
  // 解绑学员微信小程序
  unbindEmployeeOpenId: ({ commit }, params) => {
    return axios.postAsync(commit, YYGL.EMPLOYEEUNBINDOPENID, params);
  },
  // 解绑学员帐号
  unlockEmployeeLogin: ({ commit }, params) => {
    return axios.postAsync(commit, YYGL.EMPLOYEEUNLOCKLOGIN, params);
  },
  // 学员管理列表 作废
  getEmployeeMnksLearns: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EMPLOYEEMNKSLEARNS, params);
  },
  // 增加模拟考试天数
  addEmployeeMnksDays: ({ commit }, params) => {
    return axios.postAsync(commit, YYGL.EMPLOYEEMNKSDAYS, params);
  },
  // 学员档案-报名列表
  getEmployeeLearns: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EMPLOYEELEARNS, params);
  },
  // 学员档案-测试列表
  getEmployeeTests: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EMPLOYEETESTS, params);
  },
  // 学员练习情况
  getEmployeePractices: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EMPLOYEEPRACTICES, params);
  },

  getCerts: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.CERTCERTS, params);
  },
  getCertStats: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.CERTCERTSTATS, params);
  },
  getCertSources: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.CERTCERTSOURCES, params);
  },
  getCertDetails: ({ commit }, params) => {
    return axios.getAsyncWithConcat(commit, YYGL.CERTDETAILS, params);
  },
  postExportCertExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.CERTEXPORTEXCEL, params);
  },
  postInitExportCertPdf: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.CERTEXPORTPDFINIT, params);
  },
  postExportCertPdf: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.CERTEXPORTPDF, params);
  },
  postEndExportCertPdf: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.CERTEXPORTPDFEND, params);
  },
  putCertState: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.CERTSTATE, params);
  },

  // 技术工人测试批次列表
  getJsgrTestBatchs: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.JSGRTESTMGTBATCHS, params);
  },
  // 所有技术工人测试批次列表
  getAllJsgrTestBatchs: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.JSGRTESTMGTALLBATCHS, params);
  },
  // 技术工人测试批次专业统计列表
  getJsgrTestBatchJobStats: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.JSGRTESTMGTBATCHJOBSTATS, params);
  },
  // 技术工人测试批次学员列表
  getJsgrTestBatchEmployees: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.JSGRTESTMGTBATCHEMPLOYEES, params);
  },
  // 添加技术工人测试批次
  postJsgrTestBatch: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.JSGRTESTMGTBATCH, params);
  },
  // 编辑技术工人测试批次
  putJsgrTestBatch: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.JSGRTESTMGTBATCH, params);
  },
  // 删除技术工人测试批次
  deleteJsgrTestBatch: ({ commit }, params) => {
    return axios.deleteAsyncWithConcat(commit, YYGL.JSGRTESTMGTBATCH, params);
  },
  // 删除技术工人测试批次学员
  deleteJsgrTestBatchEmployee: ({ commit }, params) => {
    return axios.deleteAsync(commit, YYGL.JSGRTESTMGTBATCHEMPLOYEE, params);
  },
  // 导入学员名单
  importJsgrTestBatchEmployeeExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.JSGRTESTMGTBATCHEMPLOYEEIMPORT,
      params
    );
  },

  // 培训计划列表
  getJsgrTestTrains: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.JSGRTESTMGTTRAINS, params);
  },
  // 获得所有培训计划列表
  getAllJsgrTestTrains: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.JSGRTESTMGTALLTRAINS, params);
  },
  // 培训计划学员列表
  getJsgrTestTrainEmployees: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.JSGRTESTMGTTRAINEMPLOYEES, params);
  },
  // 添加培训计划
  postJsgrTestTrain: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.JSGRTESTMGTTRAIN, params);
  },
  // 编辑培训计划
  putJsgrTestTrain: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.JSGRTESTMGTTRAIN, params);
  },
  // 删除培训计划
  deleteJsgrTestTrain: ({ commit }, params) => {
    return axios.deleteAsyncWithConcat(commit, YYGL.JSGRTESTMGTTRAIN, params);
  },
  // 添加培训学员
  postJsgrTestTrainEmployees: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.JSGRTESTMGTTRAINEMPLOYEES,
      params
    );
  },
  // 添加全部测试场次学员
  postAllJsgrTestTrainEmployees: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.JSGRTESTMGTTRAINALLEMPLOYEES,
      params
    );
  },
  // 删除培训学员
  deleteJsgrTestTrainEmployee: ({ commit }, params) => {
    return axios.deleteAsync(commit, YYGL.JSGRTESTMGTTRAINEMPLOYEE, params);
  },
  // 导出培训学员
  exportJsgrTestTrainEmployeeExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.JSGRTESTMGTTRAINEMPLOYEEEXPORT, params);
  },
  // 导出培训计划课程课时详情
  exportJsgrTestTrainLessonExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.JSGRTESTMGTTRAINLESSONEXPORT, params);
  },
  // 开始导出培训学员照片
  initExportJsgrTestTrainEmployeeZp: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.JSGRTESTMGTTRAININITEXPORTEMPLOYEEZP,
      params
    );
  },
  // 导出培训学员照片
  exportJsgrTestTrainEmployeeZp: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.JSGRTESTMGTTRAINEXPORTEMPLOYEEZP,
      params
    );
  },
  // 结束导出培训学员照片
  endExportJsgrTestTrainEmployeeZp: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.JSGRTESTMGTTRAINENDEXPORTEMPLOYEEZP,
      params
    );
  },

  // 测试场次列表
  getJsgrTestSessions: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.JSGRTESTMGTSESSIONS, params);
  },
  // 查询测试场次详情
  getJsgrTestSessionDetailsById: ({ commit }, params) => {
    return axios.getAsyncWithConcat(
      commit,
      YYGL.JSGRTESTMGTSESSIONDETAILS,
      params
    );
  },
  // 查询测试场次学员列表
  getJsgrTestSessionEmployees: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.JSGRTESTMGTSESSIONEMPLOYEES, params);
  },
  // 查询可添加测试场次学员列表
  getAddJsgrTestSessionEmployees: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.JSGRTESTMGTSESSIONADDEMPLOYEES, params);
  },
  // 添加测试场次
  postJsgrTestSession: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.JSGRTESTMGTSESSION, params);
  },
  // 编辑测试场次
  putJsgrTestSession: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.JSGRTESTMGTSESSION, params);
  },
  // 删除测试场次
  deleteJsgrTestSession: ({ commit }, params) => {
    return axios.deleteAsyncWithConcat(commit, YYGL.JSGRTESTMGTSESSION, params);
  },
  // 添加测试场次学员
  postJsgrTestSessionEmployees: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.JSGRTESTMGTSESSIONEMPLOYEES,
      params
    );
  },
  // 编辑测试场次学员
  putJsgrTestSessionEmployee: ({ commit }, params) => {
    return axios.putFormDataAsync(
      commit,
      YYGL.JSGRTESTMGTSESSIONEMPLOYEE,
      params
    );
  },
  // 删除测试场次学员
  deleteJsgrTestSessionEmployee: ({ commit }, params) => {
    return axios.deleteAsync(commit, YYGL.JSGRTESTMGTSESSIONEMPLOYEE, params);
  },
  // 导入测试学员
  importJsgrTestSessionEmployeeExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.JSGRTESTMGTSESSIONEMPLOYEEIMPORT,
      params
    );
  },
  // 自动分配座位号
  assignJsgrTestSessionSeatNumber: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.JSGRTESTMGTSESSIONASSIGNSEATNUMBER,
      params
    );
  },
  // 初始化准考证
  initJsgrTestSessionAdmissionTicket: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.JSGRTESTMGTSESSIONINITADMISSIONTICKET,
      params
    );
  },
  // 生成准考证
  generateJsgrTestSessionAdmissionTicket: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.JSGRTESTMGTSESSIONGENERATEADMISSIONTICKET,
      params
    );
  },
  // 准考证生成结束
  endJsgrTestSessionAdmissionTicket: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.JSGRTESTMGTSESSIONENDADMISSIONTICKET,
      params
    );
  },
  // 导入测试学员成绩
  importJsgrTestSessionScoreExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.JSGRTESTMGTSESSIONSCOREIMPORT,
      params
    );
  },
  // 导出测试学员
  exportJsgrTestSessionEmployeeExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.JSGRTESTMGTSESSIONSCOREEXPORT,
      params
    );
  },

  // 测试计划批次列表
  getBdyTestPlanBatchs: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTPLANBATCHS, params);
  },
  // 获得测试计划批次专业统计列表
  getBdyTestPlanBatchJobStats: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTPLANBATCHJOBSTATS, params);
  },
  // 查询测试计划批次学员列表
  getBdyTestPlanBatchSessions: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.TESTMGTPLANBATCHSESSIONS, params);
  },
  // 添加测试计划批次
  postBdyTestPlanBatch: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.TESTMGTPLANBATCH, params);
  },
  // 编辑测试计划批次
  putBdyTestPlanBatch: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.TESTMGTPLANBATCH, params);
  },
  // 删除测试计划批次
  deleteBdyTestPlanBatch: ({ commit }, params) => {
    return axios.deleteAsyncWithConcat(commit, YYGL.TESTMGTPLANBATCH, params);
  },
  // 添加测试计划批次的测试场次
  postBdyTestPlanBatchSessions: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.TESTMGTPLANBATCHSESSIONS,
      params
    );
  },
  // 删除测试计划批次的测试场次
  deleteBdyTestPlanBatchSession: ({ commit }, params) => {
    return axios.deleteAsync(commit, YYGL.TESTMGTPLANBATCHSESSION, params);
  },

  // 八大员测试批次列表
  getBdyTestBatchs: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.BDYTESTMGTBATCHS, params);
  },
  // 八大员测试批次专业统计列表
  getBdyTestBatchJobStats: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.BDYTESTMGTBATCHJOBSTATS, params);
  },
  // 八大员测试批次详情
  getBdyTestBatchDetails: ({ commit }, params) => {
    return axios.getAsyncWithConcat(commit, YYGL.BDYTESTMGTBATCHDETAILS, params);
  },
  // 添加八大员测试批次
  postBdyTestBatch: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.BDYTESTMGTBATCH, params);
  },
  // 编辑八大员测试批次
  putBdyTestBatch: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.BDYTESTMGTBATCH, params);
  },
  // 删除八大员测试批次
  deleteBdyTestBatch: ({ commit }, params) => {
    return axios.deleteAsyncWithConcat(commit, YYGL.BDYTESTMGTBATCH, params);
  },
  // 测试批次报名开关
  enableBdyTestBatchEnroll: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.BDYTESTMGTBATCHENROLLENABLE, params);
  },
  // 测试批次场次选择开关
  enableBdyTestBatchSession: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.BDYTESTMGTBATCHSESSIONENABLE, params);
  },
  // 导出报名名单
  exportBdyTestBatchEmployeeExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.BDYTESTMGTBATCHEEMPLOYEEEXPORT, params);
  },
  // 测试批次重点练习开关
  putBdyTestBatchPracticeImportant: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.BDYTESTMGTBATCHPRACTICEIMPORTANT, params);
  },

  // 测试场次列表
  getBdyTestSessions: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.BDYTESTMGTSESSIONS, params);
  },
  // 测试场次专业统计
  getBdyTestSessionJobStats: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.BDYTESTMGTSESSIONJOBSTATS, params);
  },
  // 查询测试场次详情
  getBdyTestSessionDetails: ({ commit }, params) => {
    return axios.getAsyncWithConcat(commit, YYGL.BDYTESTMGTSESSIONDETAILS, params);
  },
  // 查询测试场次学员列表
  getBdyTestSessionEmployees: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.BDYTESTMGTSESSIONEMPLOYEES, params);
  },
  // 添加测试场次
  postBdyTestSession: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.BDYTESTMGTSESSION, params);
  },
  // 编辑测试场次
  putBdyTestSession: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.BDYTESTMGTSESSION, params);
  },
  // 删除测试场次
  deleteBdyTestSession: ({ commit }, params) => {
    return axios.deleteAsyncWithConcat(commit, YYGL.BDYTESTMGTSESSION, params);
  },
  // 添加测试场次学员
  postBdyTestSessionEmployee: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.BDYTESTMGTSESSIONEMPLOYEE, params);
  },
  // 添加测试场次学员
  postBdyTestSessionEmployees: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.BDYTESTMGTSESSIONEMPLOYEES, params);
  },
  // 编辑测试场次学员座位号
  putBdyTestSessionEmployeeSeatNumber: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.BDYTESTMGTSESSIONEMPLOYEESEATNUMBER, params);
  },
  // 删除测试场次学员
  deleteBdyTestSessionEmployee: ({ commit }, params) => {
    return axios.deleteAsync(commit, YYGL.BDYTESTMGTSESSIONEMPLOYEE, params);
  },
  // 导入测试学员
  importBdyTestSessionEmployeeExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.BDYTESTMGTSESSIONEMPLOYEEIMPORT, params);
  },
  // 导入测试学员成绩
  importBdyTestSessionScoreExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.BDYTESTMGTSESSIONSCOREIMPORT, params);
  },
  // 自动分配座位号
  assignBdyTestSessionSeatNumber: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.BDYTESTMGTSESSIONSEATNUMBERASSIGN, params);
  },
  // 初始化准考证
  initBdyTestSessionAdmissionTicket: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.BDYTESTMGTSESSIONZKZINIT, params);
  },
  // 生成准考证
  generateBdyTestSessionAdmissionTicket: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.BDYTESTMGTSESSIONZKZGENERATE, params);
  },
  // 准考证生成结束
  endBdyTestSessionAdmissionTicket: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.BDYTESTMGTSESSIONZKZEND, params);
  },
  // 导出测试考场用表
  exportBdyTestSessionKcybExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.BDYTESTMGTSESSIONKCYBEXPORT, params);
  },
  // 导出测试学员名单
  exportBdyTestSessionEmployeeExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.BDYTESTMGTSESSIONEMPLOYEEEXPORT, params);
  },
  // 测试计划重点练习开关
  putBdyTestSessionPracticeImportant: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.BDYTESTMGTSESSIONPRACTICEIMPORTANT, params);
  },
  // 学员重点练习开关
  putEmployeePracticeImportant: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.BDYTESTMGTEMPLOYEEPRACTICEIMPORTANT, params);
  },

  // 八大员测试批次列表
  getExamBatchs: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EXAMBATCHS, params);
  },
  getExamBatchCourses: ({
    commit
  }, params) => {
    return axios.getAsync(commit, YYGL.EXAMBATCHCOURSES, params);
  },
  // 八大员测试批次专业统计列表
  getExamBatchJobStats: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EXAMBATCHJOBSTATS, params);
  },
  // 八大员测试批次详情
  getExamBatchDetails: ({ commit }, params) => {
    return axios.getAsyncWithConcat(commit, YYGL.EXAMBATCHDETAILS, params);
  },
  // 添加八大员测试批次
  postExamBatch: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXAMBATCH, params);
  },
  // 编辑八大员测试批次
  putExamBatch: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.EXAMBATCH, params);
  },
  // 删除八大员测试批次
  deleteExamBatch: ({ commit }, params) => {
    return axios.deleteAsyncWithConcat(commit, YYGL.EXAMBATCH, params);
  },
  // 测试批次报名开关
  enableExamBatchEnroll: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.EXAMBATCHENROLLENABLE, params);
  },
  // 测试批次场次选择开关
  enableExamBatchSession: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.EXAMBATCHSESSIONENABLE, params);
  },
  // 导出报名名单
  exportExamBatchEmployeeExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EXAMBATCHEEMPLOYEEEXPORT, params);
  },
  // 导出审批表
  exportExamBatchSpbExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EXAMBATCHSPBEXPORT, params);
  },
  // 测试批次重点练习开关
  putExamBatchPracticeImportant: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.EXAMBATCHPRACTICEIMPORTANT, params);
  },

  // 测试场次列表
  getExamSessions: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EXAMSESSIONS, params);
  },
  getExamSessionCourses: ({
    commit
  }, params) => {
    return axios.getAsync(commit, YYGL.EXAMSESSIONCOURSES, params);
  },
  // 测试场次专业统计
  getExamSessionJobStats: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EXAMSESSIONJOBSTATS, params);
  },
  // 查询测试场次详情
  getExamSessionDetails: ({ commit }, params) => {
    return axios.getAsyncWithConcat(commit, YYGL.EXAMSESSIONDETAILS, params);
  },
  // 查询测试场次学员列表
  getExamSessionEmployees: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EXAMSESSIONEMPLOYEES, params);
  },
  // 添加测试场次
  postExamSession: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXAMSESSION, params);
  },
  // 编辑测试场次
  putExamSession: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.EXAMSESSION, params);
  },
  // 删除测试场次
  deleteExamSession: ({ commit }, params) => {
    return axios.deleteAsyncWithConcat(commit, YYGL.EXAMSESSION, params);
  },
  // 提交登记表
  postExamSessionQdb: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXAMSESSIONQDB, params);
  },
  // 提交成绩确认表
  postExamSessionCjb: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXAMSESSIONCJB, params);
  },
  // 提交人脸核验记录
  postExamSessionRljlb: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXAMSESSIONRLJLB, params);
  },
  // 添加测试场次学员
  postExamSessionEmployee: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXAMSESSIONEMPLOYEE, params);
  },
  // 添加测试场次学员
  postExamSessionEmployees: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXAMSESSIONEMPLOYEES, params);
  },
  // 编辑测试场次学员座位号
  putExamSessionEmployeeSeatNumber: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.EXAMSESSIONEMPLOYEESEATNUMBER, params);
  },
  // 删除测试场次学员
  deleteExamSessionEmployee: ({ commit }, params) => {
    return axios.deleteAsync(commit, YYGL.EXAMSESSIONEMPLOYEE, params);
  },
  // 导入测试学员
  importExamSessionEmployeeExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXAMSESSIONEMPLOYEEIMPORT, params);
  },
  // 导出测试学员成绩Excel模版
  exportExamSessionScoreTemplateExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EXAMSESSIONSCORETPLEXPORT, params);
  },
  // 导入测试学员成绩
  importExamSessionScoreExcel: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXAMSESSIONSCOREIMPORT, params);
  },
  // 自动分配座位号
  assignExamSessionSeatNumber: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXAMSESSIONSEATNUMBERASSIGN, params);
  },
  // 初始化准考证
  initExamSessionAdmissionTicket: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXAMSESSIONZKZINIT, params);
  },
  // 生成准考证
  generateExamSessionAdmissionTicket: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXAMSESSIONZKZGENERATE, params);
  },
  // 准考证生成结束
  endExamSessionAdmissionTicket: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXAMSESSIONZKZEND, params);
  },
  // 导出测试考场用表
  exportExamSessionKcybExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EXAMSESSIONKCYBEXPORT, params);
  },
  // 导出测试学员名单
  exportExamSessionEmployeeExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EXAMSESSIONEMPLOYEEEXPORT, params);
  },
  // 测试计划重点练习开关
  putExamSessionPracticeImportant: ({ commit }, params) => {
    return axios.putFormDataAsync(commit, YYGL.EXAMSESSIONPRACTICEIMPORTANT, params);
  },
  postGenerateExamSessionCertCode: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXAMSESSIONGENERATECERTCODE, params);
  },
  getExamPaperDetails: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EXAMPAPERDETAILS, params);
  },
  getExamPaperApproves: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EXAMPAPERAPPROVES, params);
  },
  postApproveExamPaper: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXAMAPPROVEPAPER, params);
  },
  postInitApproveExamBatchPaper: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXAMBATCHINITAPPROVEPAPER, params);
  },
  postInitApproveExamSessionPaper: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXAMSESSIONINITAPPROVEPAPER, params);
  },
  postOpenExamSessionEmployeeCert: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXAMSESSIONEMPLOYEEOPENCERT, params);
  },
  postOpenExamBatchCert: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXAMBATCHOPENCERT, params);
  },
  postOpenExamSessionCert: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.EXAMSESSIONOPENCERT, params);
  },
  getCert: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.CERT, params);
  },

  // 企业修改申请列表
  getEnterpriseModifyApprovesYY: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.ENTERPRISEMODIFYAPPROVESYY, params);
  },
  // 企业修改申请待审核数量
  getPendingModifyApprovalCount: ({ commit }, params) => {
    return axios.getAsync(
      commit,
      YYGL.ENTERPRISEPENDINGMODIFYAPPROVALCOUNT,
      params
    );
  },
  // 审批企业修改申请
  postApproveEnterpriseModify: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.ENTERPRISEAPPROVEMODIFY,
      params
    );
  },

  // 八大员练习报名列表
  getBdyPracticeEnrolls: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.BDYPRACTICEENROLLS, params);
  },
  // 八大员练习报名待审核数量
  getBdyPracticeEnrollApprovalCount: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.BDYPRACTICEENROLLAPPROVALCOUNT, params);
  },
  // 八大员练习报名状态
  getBdyPracticeEnrollStates: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.BDYPRACTICEENROLLSTATES, params);
  },
  // 查询八大员练习报名详情
  getBdyPracticeEnrollDetails: ({ commit }, params) => {
    return axios.getAsyncWithConcat(
      commit,
      YYGL.BDYPRACTICEENROLLDETAILS,
      params
    );
  },
  // 审批企业修改申请
  postApproveBdyPracticeEnroll: ({ commit }, params) => {
    return axios.postFormDataAsync(
      commit,
      YYGL.BDYPRACTICEENROLLAPPROVE,
      params
    );
  },
  // 十大员题目管理列表
  getQuestionYYs: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.QUESTIONQUESTIONS, params);
  },
  // 八大员题目管理列表
  getBdyQuestions: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.QUESTIONBDYQUESTIONS, params);
  },

  // 获得课程报名开票列表
  getLearnInvoices: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNINVOICELEARNINVOICES, params);
  },
  getLearnInvoiceGkDKPCount: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNINVOICEGKDKPCOUNT, params);
  },
  getLearnInvoicePxDKPCount: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNINVOICEPXDKPCOUNT, params);
  },
  // 获得课程报名开票详情
  getLearnInvoiceDetails: ({ commit }, params) => {
    return axios.getAsyncWithConcat(commit, YYGL.LEARNINVOICEDETAILS, params);
  },
  // 获得课程报名开票状态列表
  getLearnInvoiceStates: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNINVOICESTATES, params);
  },
  // 课程报名开票
  postLearnInvoice: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.LEARNINVOICEKP, params);
  },
  // 导出电票文件
  expertLearnInvoiceDpwj: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNINVOICEEXPERTDPWJ, params);
  },
  // 导出电票文件
  expertLearnInvoiceDpExcel: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.LEARNINVOICEEXPERTDPEXCEL, params);
  },

  getApproveCertReplaces: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.CERTREPLACEAPPROVECERTREPLACES, params);
  },
  getCertReplaceApproves: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.CERTREPLACEAPPROVES, params);
  },
  getApproveCertReplaceCount1: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.CERTREPLACEAPPROVECERTREPLACECOUNT1, params);
  },
  getApproveCertReplaceCount2: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.CERTREPLACEAPPROVECERTREPLACECOUNT2, params);
  },
  getCertReplaceApproveActions: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.CERTREPLACEAPPROVEACTIONS, params);
  },
  postApproveCertReplace: ({ commit }, params) => {
    return axios.postFormDataAsync(commit, YYGL.CERTREPLACEAPPROVE, params);
  },

  getAllEmployeeChangeApproves: ({ commit }, params) => {
    return axios.getAsync(commit, YYGL.EMPLOYEECHANGEAPPROVEALL, params);
  }
};

export default yyglAction;



// WEBPACK FOOTER //
// ./src/store/jzjy/actions/yyglAction.js